import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { investorApi } from "../../api/api";
import { useLocation } from "react-router-dom";

const ChangePassword = () => {
  const location = useLocation();
  const { userId } = location.state || {};

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async () => {
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("newPassword", newPassword);
      fd.append("userId", userId);

      const response = await investorApi.changePasswordById(fd);

      if (response?.data?.error) {
        setError(response.data.message || "Failed to change password.");
      } else {
        setSuccess("Password changed successfully!");
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (err) {
      setError("An error occurred while changing password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Card sx={{ maxWidth: 400, width: "100%", p: 3, borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom>
            Change Password
          </Typography>

          <TextField
            fullWidth
            margin="normal"
            type={showPassword ? "text" : "password"}
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            type={showPassword ? "text" : "password"}
            label="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {error && (
            <Typography color="error" variant="body2" mt={1}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success.main" variant="body2" mt={1}>
              {success}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2, borderRadius: 2 }}
            onClick={handleChangePassword}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Change Password"}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ChangePassword;
